import React from 'react';
import {Typography} from "material-ui";

export default () => {
    return (
        <div>
            <Typography type="title">
                About
            </Typography>
            <p>some stuff</p>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/Views/AboutView.js